<template>
  <v-card elevation-0>
    <v-card-title class="ml-5 mr-5 pa-5">
      <v-icon color="grey darken-2">mdi-map-marker</v-icon>

      <div class="subtitle-1 font-weight-medium pl-2">Site Address:</div>

      <div class="subtitle-1 pl-2">{{ site.address }}</div>

      <v-spacer></v-spacer>
      <v-btn rounded color="primary" class="ma-2" @click="save" :disabled="disabled">
        <v-icon class="pr-2">mdi-content-save</v-icon>
        Save
      </v-btn>
    </v-card-title>


    <v-row>
      <v-container grid-list-md>
        <v-layout wrap class="pa-5">
          <v-flex xs12>
            <div class="subtitle-1">
              Filling these details is optional, however, it will help the
              inspector prepare for your site inspection.
            </div>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="site.pools"
              :items="options.spools"
              clearable
              label="How many swimming pools are there on the site?"
              :disabled="disabled"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
              :items="options.binary"
              v-model="site.boardwalk"
              label="Does the site have a jetty, boardwalk or pontoon?"
              single-line
              clearable
              :disabled="disabled"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
              :items="options.preps"
              v-model="site.prep"
              label="Is there is a cyclone preparation plan for the site?"
              single-line
              clearable
              :disabled="disabled"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="site.building_count"
              label="How many different types of buildings are on the property?"
              type="number"
              :disabled="disabled"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-row>
  </v-card>
</template>

<script>
import { router } from "../router";
import { answers } from "../helpers";

export default {
  name: "Details",
  props: ["site"],
  data: () => ({
    disabled: false,
    options: answers,
    pools: "",
    boardwalk: "",
    prep: "",
    buildings: "",
    someRules: [
      v => !!v || "CTSN is required",
      v => (v && v.length <= 20) || "CTSN must be less than 20 characters"
    ]
  }),

  mounted() {
    if (this.site.inspection_status.toString() !== "P" ){
      this.disabled = true;
    }
  },
  methods: {
    input: function() {
      this.changed = true;
    },
    validate() {

    },
    save() {
      //TODO put in conditions of success here
      const site = this.site;
      this.$store.dispatch("sites/saveSite", { site: site } );
    }
  }
};
</script>
